module.exports = __webpack_public_path__ + "img/landing-btn-contact-icon.5503376d.svg";